export const notifLayouts = {
  ADR_SUBMITTED: {
    color: "warning",
    badgeText: "Review Needed",
    notifText: notif => notif.title,
    notifSince: notif => notifSince(notif),
    actionButtons: ["Review"],
    showDismiss: false
  },
  ADR_REJECTED: {
    color: "danger",
    badgeText: "Revision Needed",
    notifSince: notif => notifSince(notif),
    actionButtons: ["View & Edit"],
    showDismiss: false
  },
  ADR_APPROVED: {
    color: "success",
    badgeText: "Accepted",
    notifSince: notif => notifSince(notif),
    actionButtons: [],
    showDismiss: true
  },
  PROJECT_ASSIGNED: {
    color: "info",
    badgeText: "New Project Assigned",
    notifSince: notif => notifSince(notif),
    actionButtons: [],
    showDismiss: true
  },
  LABOR_ADDED: {
    color: "warning",
    badgeText: "New Labor Added",
    notifSince: notif => notifSince(notif),
    actionButtons: ["Review"],
    showDismiss: false
  },
  EQUIPMENT_ADDED: {
    color: "warning",
    badgeText: "New Equipment Added",
    notifSince: notif => notifSince(notif),
    actionButtons: ["Review"],
    showDismiss: false
  },
  OTHER: {
    color: "secondary",
    badgeText: "Information",
    notifSince: notif => notifSince(notif),
    actionButtons: [],
    showDismiss: true
  }
};

const notifSince = notif => {
  const today = new Date();
  const notifDate = new Date(notif.raisedOn);
  const diff = Math.floor(
    (today.getTime() - notifDate.getTime()) / 1000 / 3600 / 24
  );
  const dayStr = diff > 1 ? "days ago" : diff === 1 ? "day ago" : "today";
  return diff === 0 ? "today" : `${diff.toString()} ${dayStr}`;
};
